
// ******** ! THESE MUST MATCH API ENUMS NUMBERING ! ********

enum StringValueType {
    Invalid = 0,
    MobilePhone8 = 1,
    EmailAddress = 2,
    TextMin3 = 3,
    NumberMax9 = 4
}

enum OwnerLoginStage {
    Start = 0,
    Code = 1,
    Refresh = 2
}

enum OwnerLoginAttemptStatus {
    New = 0,
    Success = 1,
    InvalidLoginCodeId = 2,
    InvalidMobileOrEmail = 3,
    MobileOrEmailMismatch = 4,
    LoginCodeMismatch = 5,
    LoginCodeExpired = 6,
    NoMoreAttempts = 7,
    DbError = 99
}

enum NotificationStatus {
    New = 0,
    Sent = 1,
    Fail = 2
}

enum UserLoginStatus {
    New = 0,
    Success = 1,
    UnknownUser = 2,
    InvalidPwd = 3,
    NoMoreAttempts = 4,
    NotActive = 5,
    DbError = 99
}

enum ConsentStatus {
    Inactive = 0,
    Active = 1,
    Revoked = 2,
    Test = 99
}

enum ConsentTypeContact
{
    SMS = 0,
    Email = 1,
    Phone = 2
    //SocialMedia = 3,
    //PostalMail = 4
}

enum UserType {
    Developer = 0,
    Administrator = 1,
    Support = 2,
    Stakeholder = 3
}

enum StakeholderType {
    Administrator = 0,
    Advertiser = 1,
    Supplier = 2,
    Processor = 3
}

enum StakeholderFileType
{
    Other = 0,
    Contract = 1,
    Logo = 2
}

enum AccessPermissionType
{
    None = 0,
    Upload = 1,
    Revoke = 2,
    Both = 3
}

enum ListType
{
    none = 0,
    AuxType = 1,
    ConsentType = 2
}

enum StakeholderPageStage {
    Clean = 0,
    Logo = 1,
    Details = 2,
    Edit = 3,
    AuxTypes = 4,
    Partners = 5,
    Comms = 6,
    Contract = 7,
    PullRequest =8
}


enum AuthenticationType
{
    None = 0,
    Basic = 1,
    Bearer = 2,
    RefreshTokenPOST = 3,
    RefreshTokenGET = 4
}

enum HttpTransferType
{
    POST = 0,
    GET = 1
}

enum PullRequestDataField
{
    Fixed = 0,
    RequestDateTime = 1,
    AdvertiserId = 5,
    MobileOrEmail = 10,
    MobilePhone = 11,
    Email = 12,
    RefreshToken = 15
}

enum NotificationField
{
    Fixed = 0,
    AdvertiserId = 5,
    Advertiser = 6,
    CampaignId = 7,
    CampaignTitle = 8,
    MobilePhone = 10,
    Email = 11,
    Phone = 12,
    Firstname = 15,
    Lastname = 16,
    FullName = 17,
    Address = 18,
    PostalCode = 19,
    City = 20,
    Gender = 25,
    DateOfBirth = 26,
    SignupURL = 27,
    ConsentDateTime = 28,
    RefreshToken = 30
}

enum ApiUserRequestType
{
    Unknown = 0,
    TestCall = 1,
    AuthTestCall = 2,
    CreateConsent = 3,
    RevokeConsent = 4
}

enum LogType
{
    None = 0,
    ApiUserRequest = 1,
    AppUserActivity = 2,
    AppUserLogin = 3,
    ConsentList = 4,
    ConsentHistory = 5,
    OwnerLogin = 6,
    OwnerRevokeInvitation = 7,
    StakeholderRevokeNotification = 8,
    OwnerRevokeNotification = 9,
    ConsentRevokeCollection = 10,
    ConsentPullRequest = 11
}

enum StatisticsPeriod
{
    Today = 0,
    Yesterday = 1,
    WeekToDate = 2,
    MonthToDate = 3,
    YearToDate = 4,
    PrevWeek = 5,
    PrevMonth = 6,
    PrevYear = 7
}

enum ApiLogType
{
    Request = 0,
    Response = 1,
    Failed = 2
}

enum NotificationCommsType
{
    Webservice = 0,
    Email = 1,
    Sms = 2
}

enum SureSmsCallbackStatus
{
    None = 0,
    Success = 1,
    Failure = 2,
    InQueue = 4,
    WillNeverHappen = 8,
    ErrorReadingCallBack = 99
}

enum ConsentRevokeReasonType
{
    None = 0,
    Other = 1,
    DidNotRequest = 10,
    ContactWrong = 11,
    Spam = 12
}


// * These MUST match the returned json keys! *
const webserviceFieldsDataTypes: any = {
    advertiserId: "<numeric>",
    advertiserConsentId: "(Advertiser's unique ID)",
    campaignId: "(Advertiser's campaign ID)",
    campaignTitle: "",
    mobilePhone: "6 number string",
    email: "",
    phone: "6 number string",
    firstname: "",
    lastname: "",
    address: "",
    postalCode: "4 number string",
    city: "",
    gender: "M/F",
    dateOfBirth: "dd-mm-yyyy",
    signupIP: "",
    signupURL: "",
    consentDateTime: "See 'consentDateTime'",
    screenshotUrl1: "",
    screenshotUrl2: "",
    videoUrl: ""
};


export { StringValueType, OwnerLoginStage, OwnerLoginAttemptStatus, NotificationStatus, UserLoginStatus, ConsentStatus, ConsentTypeContact, UserType,
    StakeholderType, StakeholderFileType, AccessPermissionType, ListType, StakeholderPageStage, AuthenticationType, HttpTransferType, PullRequestDataField,
    NotificationField, ApiUserRequestType, LogType, StatisticsPeriod, ApiLogType, NotificationCommsType, SureSmsCallbackStatus, ConsentRevokeReasonType,
    webserviceFieldsDataTypes }
